module.exports = __webpack_public_path__ + "img/delete.0c530b03.svg";